module.exports = __webpack_public_path__ + "static/media/pg_table_bg_shifted.5e496763.jpg";